<div class="social-links-wrapper">
  <a href="https://www.youtube.com/user/Archicad" target="_blank" class="youtube"></a>
  <a href="https://www.facebook.com/archicad/" target="_blank" class="facebook"></a>
  <a href="https://www.instagram.com/graphisoft/" target="_blank" class="instagram"></a>
  <a href="https://twitter.com/Archicad" target="_blank" class="twitter"></a>
  <a href="https://www.linkedin.com/company/graphisoft" target="_blank" class="linkedin"></a>
</div>
